export const getFromState = (getState, key) => {
  return getState()[key].data.toJS();
};
